/**
 * Logic `main_modules2` field
 * which depends on `basic_coverage_postcode_validation_contents`
 * from quote responce.
 */
export default (kasko) => {
  kasko.addEventListener(
    'state-changed',
    (validation) => {
      if (validation === true || validation === false) {
        kasko.dispatchEvent('set-state-input', {
          main_modules2_quote_settings: validation,
          main_modules2: validation,
        });
        kasko.dispatchEvent('set-form-input', {
          main_modules2_quote_settings: validation,
          main_modules2: validation,
        });
        kasko.dispatchEvent('trigger-requests');
      }
    },
    { slice: 'quote.data.extraData.basic_coverage_postcode_validation_contents' },
  );
};
